import { Button } from "@/components/ui/button";
import { ArrowRight, ExternalLink } from "lucide-react";
import heroImage from "@/assets/hero-blue-dress.jpg";

const Hero = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      element.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-background">
      <div className="container mx-auto px-4 py-32 md:py-40">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="order-2 md:order-1">
            <p className="text-[0.7rem] md:text-[0.75rem] uppercase tracking-[0.25em] text-accent font-semibold mb-5">
              Real Estate Broker. Mortgage Advisor. AI Systems Builder.
            </p>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Build the systems that run your{" "}
              <span className="text-primary">real estate business.</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-4 leading-relaxed">
              I help real estate professionals replace scattered tools and manual
              follow-up with practical AI systems they understand and own.
            </p>
            <p className="text-lg md:text-xl font-semibold text-foreground mb-8">
              I don&apos;t teach what I read. I teach what I run.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 flex-wrap">
              <a
                href="https://freshvisionacademy.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button size="lg" variant="premium" className="w-full sm:w-auto group">
                  Explore Fresh Vision Academy
                  <ExternalLink className="ml-2 w-4 h-4" />
                </Button>
              </a>
              <Button
                size="lg"
                variant="outline"
                className="w-full sm:w-auto group"
                onClick={() => scrollToSection("products-built")}
              >
                See What I&apos;ve Built
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>

          {/* Hero Image */}
          <div className="order-1 md:order-2 flex justify-center md:justify-end">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary/15 to-accent/15 rounded-full blur-2xl" />
              <img
                src={heroImage}
                alt="Marquetta Bryant, real estate broker, Mortgage Advisor and AI systems builder"
                className="relative w-80 h-80 md:w-[450px] md:h-[450px] object-cover object-top rounded-full shadow-luxury border-4 border-background"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
